import { Box, Typography, Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Link as RouterLink } from 'react-router';

import { paths } from '@/config/paths';

const NotFoundRoute = () => {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        mt: 8,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        fontWeight: 600,
      }}
    >
      <Typography variant="h4" component="h1" gutterBottom>
        {t('notFound.title')}
      </Typography>
      <Typography variant="body1" gutterBottom>
        {t('notFound.description')}
      </Typography>
      <Button
        component={RouterLink}
        to={paths.home.getHref()}
        replace
        variant="contained"
        color="primary"
        sx={{ mt: 2 }}
      >
        {t('common.buttons.goHome')}
      </Button>
    </Box>
  );
};

export default NotFoundRoute;
